// Modal Content, This content is mainly used for Modal wrap with MainModal.tsx Component
import React, { useState } from "react";
import { FiUpload } from "react-icons/fi";
import { BsCameraVideo } from "react-icons/bs";
import { InputField } from "./InputField";
import cover from "../assets/images/Rectangle 18156.png";
import PrimaryButton from "./PrimaryButton";
import { PiTranslateBold } from 'react-icons/pi';
import { GrFormEdit } from "react-icons/gr";
import GroupFileCard from "./GroupFileCard";
import { ActionBothProps, ActionNextProps } from "../types/common";
import SelectOption from "./SelectOption";

const UploadFileModal: React.FC<ActionNextProps> = ({showNext}) => {
  const [showIndex, setShowIndex] = useState<number>(1);
  return (
    <>
      <p className="text-[#0F0C18] text-[26px] font-medium tracking-tight">Upload new file</p>
        <p className="text-[#9392A2] text-sm font-medium tracking-tight">Select how you want to proceed with uploading.</p>
        <p className="text-[#9392A2] text-xs font-medium tracking-tight mt-4">Type of the file</p>
        <div className="w-[358px] h-[40px] rounded-full border border-[#EAE9EF] bg-white flex items-center px-[2px] my-3">
          <div
            onClick={() => setShowIndex(1)}
            className={`w-[50%] h-[34px] rounded-full flex items-center justify-center gap-1 cursor-pointer transition duration-300 ease-in-out ${showIndex === 1 && "bg-[#EAE9EF]"}`}
          >
            <p className={`text-center text-sm font-medium tracking-tight select-none ${showIndex === 1 ? "text-[#0F0C18]" : "text-[#9392A2]"}`}>Video</p>
          </div>
          <div
            onClick={() => setShowIndex(2)}
            className={`w-[50%] h-[34px] rounded-full flex items-center justify-center gap-1 cursor-pointer transition duration-300 ease-in-out ${showIndex === 2 && "bg-[#EAE9EF]"}`}
          >
            <p className={`text-center text-sm font-medium tracking-tight select-none ${showIndex === 2 ? "text-[#0F0C18]" : "text-[#9392A2]"}`}>Audio</p>
          </div>
      </div>
      <div className="text-[#9392A2] text-xs font-medium tracking-tigh mt-7 mb-3">Record or upload</div>
      <div className="flex items-center gap-3 p-3 bg-white rounded-xl cursor-pointer mb-2">
        <FiUpload className="text-[#9392A2]" />
        <p className="text-[#0F0C18] text-sm font-medium tracking-tight">Upload from your device</p>
      </div>
      <div className="flex items-center gap-3 p-3 bg-white rounded-xl cursor-pointer">
        <BsCameraVideo className="text-[#9392A2]" />
        <p className="text-[#0F0C18] text-sm font-medium tracking-tight">Record new video</p>
      </div>
      <div className="text-[#9392A2] text-xs font-medium tracking-tigh mt-7 mb-3">Direct link</div>
      <InputField label="Paste a link" />
      <PrimaryButton onClick={() => showNext && showNext()} label="Proceed" black className="py-2.5 rounded-3xl w-full mt-3" />
    </>
  );

};
export const UploadFileModalStep2: React.FC<ActionBothProps> = ({showPrev, showNext}) => {
  return (
    <>
      <p className="text-[#0F0C18] text-[26px] font-medium tracking-tight">Upload new file</p>
      <p className="text-[#9392A2] text-sm font-medium tracking-tight mb-5 mt-2">Select how you want to proceed with uploading.</p>
      <div className="mb-2">
        <InputField label="Video name" />
      </div>
      <SelectOption label="Group" options={["Game video"]} />
      <img src={cover} className="w-full h-[200px] my-4" alt="cover" />
      <div className="flex items-center justify-between mb-4">
        <div>
          <p className="text-[#0F0C18] text-base font-medium tracking-tight">15:32</p>
          <p className="text-[#9392A2] text-xs font-medium tracking-tight">15 Mb • MP4</p>
        </div>
        <div className="flex items-center gap-1">
          <PiTranslateBold className="text-[#9392A2]" />
          <p className="text-[#9392A2] text-xs font-medium tracking-tight">English</p>
          <GrFormEdit className="text-[#0F0C18]" />
        </div>
      </div>
      <div className="flex items-center gap-2">
        <PrimaryButton className="w-full py-2.5 rounded-3xl" label="Translate options" black />
        <PrimaryButton onClick={() => showNext && showNext()} className="w-full py-2.5 rounded-3xl" label="Save" />
      </div>
    </>
  );
};

export const UploadFileModalStep3: React.FC<ActionBothProps> = ({showPrev, showNext}) => {
  return (
    <>
      <p className="text-[#0F0C18] text-[26px] font-medium tracking-tight">Choose group</p>
      <p className="text-[#9392A2] text-sm font-medium tracking-tight mb-5 mt-2">Create new group or select existing one.</p>
      <div className="text-[#9392A2] text-xs font-medium mb-2 tracking-tight">Create new group</div>
      <div className="mb-3">
        <InputField label="Enter group name" />
      </div>
      <PrimaryButton className="w-full py-3 rounded-3xl" label="Create group" black />
      <div className="text-[#9392A2] text-xs font-medium mt-5 mb-2 tracking-tight">Select from the exisitng</div>
      <GroupFileCard check className="w-full mb-2 mt-4" />
      <GroupFileCard check className="w-full mb-3" />
      <div className="flex items-center gap-2">
        <PrimaryButton onClick={() => showPrev && showPrev()} className="w-full py-2.5 rounded-3xl" label="Back" black />
        <PrimaryButton className="w-full py-2.5 rounded-3xl" label="Confirm" />
      </div>
    </>
  );
};

export default UploadFileModal;